import type { AppRouter } from "@server/routers/appRouter.ts";
import { loggerLink, type TRPCLink } from "@trpc/client";

type LoggerOptions = Parameters<typeof loggerLink<AppRouter>>[0];

export const createTrpcLoggerLink =
  (options: LoggerOptions): TRPCLink<AppRouter> =>
  (runtime) => {
    const log = loggerLink<AppRouter>(options)(runtime);
    return (opts) => {
      if (
        opts.op.path.startsWith("auth.") ||
        opts.op.path.startsWith("users.") ||
        opts.op.path.startsWith("testUsers.")
      ) {
        return opts.next(opts.op);
      }
      return log(opts);
    };
  };
